import { computed, inject, Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RouterService {
  private readonly router = inject(Router);

  private readonly currentUrlSig = signal<string | null>(null);
  private readonly previousUrlSig = signal<string | null>(null);

  private readonly hasPreviousUrlSig = computed(() => this.previousUrlSig() !== null);

  constructor() {
    // Seed with current URL if service is created after initial navigation
    if (this.router.url) {
      this.currentUrlSig.set(this.router.url);
    }

    this.router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd)).subscribe((e) => {
      this.previousUrlSig.set(this.currentUrlSig());
      this.currentUrlSig.set(e.urlAfterRedirects);
    });
  }

  readonly currentUrl = this.currentUrlSig.asReadonly();
  readonly previousUrl = this.previousUrlSig.asReadonly();
  readonly hasPreviousUrl = this.hasPreviousUrlSig;
}
